import React, { useState } from 'react';
import AnimatedStep from '../components/AnimatedStep';
import StepOne from '../components/OccupationalHealthStarterQuestionnaire/StepOne';
import StepTwo from '../components/OccupationalHealthStarterQuestionnaire/StepTwo';
import StepThree from '../components/OccupationalHealthStarterQuestionnaire/StepThree';
import StepFour from '../components/OccupationalHealthStarterQuestionnaire/StepFour';
import StepFive from '../components/OccupationalHealthStarterQuestionnaire/StepFive';
import StepSix from '../components/OccupationalHealthStarterQuestionnaire/StepSix';
import StepSeven from '../components/OccupationalHealthStarterQuestionnaire/StepSeven';
import StepEight from '../components/OccupationalHealthStarterQuestionnaire/StepEight';
import StepNine from '../components/OccupationalHealthStarterQuestionnaire/StepNine';
import StepTen from '../components/OccupationalHealthStarterQuestionnaire/StepTen';
import StepEleven from '../components/OccupationalHealthStarterQuestionnaire/StepEleven';
import StepTwelve from '../components/OccupationalHealthStarterQuestionnaire/StepTwelve';
import StepThirteen from '../components/OccupationalHealthStarterQuestionnaire/StepThirteen';
import StepFourteen from '../components/OccupationalHealthStarterQuestionnaire/StepFourteen';
import StepFifteen from '../components/OccupationalHealthStarterQuestionnaire/StepFifteen';
import StepSixteen from '../components/OccupationalHealthStarterQuestionnaire/StepSixteen';
import StepSeventeen from '../components/OccupationalHealthStarterQuestionnaire/StepSeventeen';
import StepEighteen from '../components/OccupationalHealthStarterQuestionnaire/StepEighteen';
import StepNineteen from '../components/OccupationalHealthStarterQuestionnaire/StepNineteen';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Link } from 'react-router-dom';
import { post } from '../services/ApiService';

function StarterQuestionnaire() {
    const [step, setStep] = useState(1);
    const [formData, setFormData] = useState({});
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleNext = (data) => {
        setFormData(prev => ({ ...prev, ...data }));

        if (step === 11) { 
            handleSubmit(); 
        } else { 
            setStep(prev => prev + 1); 
        }
    };


    const handleSubmit = async () => {
        setIsSubmitting(true);
        await new Promise(resolve => setTimeout(resolve, 500)); 
        console.log(formData);
        const payload = {...formData}
        try {
            const res = await post("home/health/questions/submit", payload);
            if (res.success) {
                setStep(prev => prev + 1); // Move to success/thank you page
            } else {
                alert("Failed to submit");
            }
        } catch (error) {
            alert("Failed to submit");
        } finally {
            setIsSubmitting(false); // Always reset regardless of success/failure
        }
    }



    const handleBack = () => {
        setStep(prev => Math.max(prev - 1, 1));
    };

    const stepProps = {
        onNext: handleNext,
        formData,
    };

    const renderStep = () => {
        switch (step) {
            case 1: return <StepOne {...stepProps} />;
            case 2: return <StepTwo {...stepProps} />;
            case 3: return <StepThree {...stepProps} />;
            case 4: return <StepFour {...stepProps} />;
            case 5: return <StepFive {...stepProps} />;
            case 6: return <StepSix {...stepProps} />;
            case 7: return <StepSeven {...stepProps} />;
            case 8: return <StepEight {...stepProps} />;
            case 9: return <StepNine {...stepProps} />;
            case 10: return <StepTen {...stepProps}  />;
            case 11: return <StepEleven {...stepProps}  isSubmitting={isSubmitting}  />;
            case 12: return <StepNineteen />;
            default: return null;
        }
    };

    return (
        <div className="container step_form_wrap py-2">
            <div className="row justify-content-center">
                <div className="col-md-8">
                    <div className="step_form_wrap_main_ques">
                        {/* <Link to='/'> */}
                        <img
                            src="/assets/logo.png"
                            alt="Crowded Logo"
                            className='logo_steps'
                        />
                        {/* </Link> */}
                        {step !== 12 &&
                            <h5 className="my-4">Step {step} / 11</h5>
                        }


                        <AnimatedStep stepKey={step}>
                            {renderStep()}
                        </AnimatedStep>

                        <div className="d-flex justify-content-between bk_btn">
                            {step > 1 && step < 11 && (
                                <button className="btn btn-light btn-light-step px-4" onClick={handleBack}>
                                    Back
                                </button>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default StarterQuestionnaire;
